module.exports = __webpack_public_path__ + "img/quick_release_02.5b1244f9.png";